// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__zdGvj","menuItem":"Navbar_menuItem__6UTC2","menuItemHover":"Navbar_menuItemHover__CmZkv"};